export default "__VITE_ASSET__CUVEd3Fl__"